import { render } from "./add-material-lesson.vue?vue&type=template&id=73b1793e&ts=true"
import script from "./add-material-lesson.vue?vue&type=script&lang=ts"
export * from "./add-material-lesson.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__